import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import Flex from "../Flex";
import { themeGet } from 'styled-system';

var Container = /*#__PURE__*/_styled(Flex, {
  target: "edfmrtu0",
  label: "Container"
})("border-left:", themeGet('borders.3'), " ", function (props) {
  return themeGet("stripe.".concat(props.variant, ".color"));
}, ";align-self:flex-start;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1N0cmlwZUNvbnRlbnRDb250YWluZXIvU3RyaXBlQ29udGVudENvbnRhaW5lci5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTThCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1N0cmlwZUNvbnRlbnRDb250YWluZXIvU3RyaXBlQ29udGVudENvbnRhaW5lci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBGbGV4IGZyb20gJy4uL0ZsZXgnO1xuaW1wb3J0IHsgdGhlbWVHZXQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkKEZsZXgpYFxuICBib3JkZXItbGVmdDogJHt0aGVtZUdldCgnYm9yZGVycy4zJyl9XG4gICAgJHsocHJvcHMpID0+IHRoZW1lR2V0KGBzdHJpcGUuJHtwcm9wcy52YXJpYW50fS5jb2xvcmApfTtcbiAgYWxpZ24tc2VsZjogZmxleC1zdGFydDtcbmA7XG5cbmNvbnN0IFN0cmlwZUNvbnRlbnRDb250YWluZXIgPSAocHJvcHMpID0+IChcbiAgPENvbnRhaW5lciBwbD17M30gZGF0YS10ZXN0aWQ9XCJzdHJpcGVDb250YWluZXJcIiB7Li4ucHJvcHN9PlxuICAgIHtwcm9wcy5jaGlsZHJlbn1cbiAgPC9Db250YWluZXI+XG4pO1xuXG5TdHJpcGVDb250ZW50Q29udGFpbmVyLnByb3BUeXBlcyA9IHtcbiAgdmFyaWFudDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUuaXNSZXF1aXJlZCxcbn07XG5cblN0cmlwZUNvbnRlbnRDb250YWluZXIuZGVmYXVsdFByb3BzID0ge1xuICB2YXJpYW50OiAnZGVmYXVsdCcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTdHJpcGVDb250ZW50Q29udGFpbmVyO1xuIl19 */"));

var StripeContentContainer = function StripeContentContainer(props) {
  return /*#__PURE__*/React.createElement(Container, _extends({
    pl: 3,
    "data-testid": "stripeContainer"
  }, props), props.children);
};

StripeContentContainer.propTypes = {
  variant: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
StripeContentContainer.defaultProps = {
  variant: 'default'
};
export default StripeContentContainer;